import { Biometrics, IBiometrics } from './biometrics';
import { Certificates, ICertificates } from './certificates';
import { Diploma, IDiploma } from './diploma';
import { DpInfo, IDpInfo } from './dp-info';
import { IdentificationDocument, IIdentificationDocument } from './identification-document';
import { IJobExperience, JobExperience } from './job-experience';
import { Certificate, ICertificate } from '../certificate';
import { IResume, Resume } from './resume';
import { IReference, Reference } from './reference';
import { ISkills, Skills } from './skills';
import { IWellsSpecifications, WellsSpecifications } from './wells-specifications';
import { Educations, IEducations } from './education';
import { IJobRequirements, JobRequirements } from './job-requirements';
import { ISeaJobExperience, SeaJobExperience } from './sea-job-experience';
import { IMedicalAndVaccination, MedicalAndVaccination } from './medical-and-vaccination';
import { ILocationAndVisas, LocationAndVisas } from './location-and-visas';
import { JobExperienceType } from './employment-history';

export interface IAdditionalInfo {
  kinEmail?: string;
  kinPerson?: string;
  kinPhone?: string;
  kinSkype?: string;
  kin_name_surname?: string;
  maritalStatus?: string;
}

export interface ICv {
  additionalPersonalInfo?: IAdditionalInfo;
  closest_airport?: string;
  biometrics?: IBiometrics;
  certificates?: ICertificates;
  diplomaAndEndorsement?: IDiploma[];
  dp_info?: IDpInfo;
  education?: IEducations;
  identificationDocument?: IIdentificationDocument[];
  job_experience?: IJobExperience[];
  sea_services?: any[];
  job_requirements?: IJobRequirements;
  location_and_visas?: ILocationAndVisas;
  medical_and_vaccination?: IMedicalAndVaccination;
  my_resume?: IResume;
  nationality?: string;
  reference?: IReference[];
  skills_and_ability?: ISkills;
  training_and_courses?: ICertificate[];
  wells_specification?: IWellsSpecifications;
  job_experience_type?: JobExperienceType;
}

export class Cv {
  additionalPersonalInfo: IAdditionalInfo;
  closest_airport: string;
  biometrics: Biometrics;
  certificates: Certificates;
  diplomaAndEndorsement: Diploma[];
  dp_info: DpInfo;
  education: Educations;
  identificationDocument: IdentificationDocument[];
  job_experience: JobExperience[];
  sea_services: SeaJobExperience[];
  job_requirements: JobRequirements;
  location_and_visas: ILocationAndVisas;
  medical_and_vaccination: IMedicalAndVaccination;
  my_resume: Resume;
  nationality: string;
  reference: Reference[];
  skills_and_ability?: Skills;
  training_and_courses?: Certificate[];
  wells_specification?: WellsSpecifications;
  job_experience_type?: JobExperienceType;

  constructor( cv: ICv = {} ) {
    this.additionalPersonalInfo = cv.additionalPersonalInfo || {};
    this.closest_airport = cv.closest_airport;
    this.biometrics = new Biometrics(cv.biometrics);
    this.certificates = new Certificates(cv.certificates);
    this.diplomaAndEndorsement = this.transformDiplomas(cv.diplomaAndEndorsement);
    this.dp_info = new DpInfo(cv.dp_info);
    this.education = new Educations(cv.education);
    this.identificationDocument = this.transformIdentificationDocs(cv.identificationDocument);
    this.job_experience = this.transformJobExperiences(cv.job_experience);
    this.sea_services = this.transformSeaJobExperiences(cv.sea_services);
    this.job_requirements = new JobRequirements(cv.job_requirements);
    this.location_and_visas = new LocationAndVisas(cv.location_and_visas);
    this.nationality = cv.nationality;
    this.medical_and_vaccination = new MedicalAndVaccination(cv.medical_and_vaccination);
    this.my_resume = new Resume(cv.my_resume);
    this.reference = this.transformReferences(cv.reference);
    this.skills_and_ability = new Skills(cv.skills_and_ability);
    this.training_and_courses = this.transformCertificates(cv.training_and_courses);
    this.wells_specification = new WellsSpecifications(cv.wells_specification);
    this.job_experience_type = cv.job_experience_type || 'job_experience';
    // this.job_experience_type = cv.job

  }

  private transformDiplomas( diplomas: IDiploma[] = [] ): Diploma[] {
    if ( diplomas.length < 1 ) {
      return [ new Diploma() ];
    }
    return diplomas.map(( diploma ) => new Diploma(diploma));
  }

  private transformIdentificationDocs( docs: IIdentificationDocument[] = [] ): IdentificationDocument[] {
    if ( docs.length < 1 ) {
      return [ new IdentificationDocument() ];
    }
    return docs.map(( document ) => new IdentificationDocument(document));
  }

  private transformJobExperiences( experiences: IJobExperience[] = [] ): JobExperience[] {
    if ( experiences.length < 1 ) {
      return [ new JobExperience() ];
    }
    return experiences.map(( experience ) => new JobExperience(experience));
  }

  private transformReferences( references: IReference[] = [] ): Reference[] {
    if ( references.length < 1 ) {
      return [ new Reference() ];
    }
    return references.map(( reference ) => new Reference(reference));
  }

  private transformCertificates( certificates: ICertificate[] = [] ): Certificate[] {
    if ( certificates.length < 1 ) {
      return [ new Certificate() ];
    }
    return certificates.map(( certificate ) => new Certificate(certificate));
  }

  private transformSeaJobExperiences( seaJobs: ISeaJobExperience[] = [] ): SeaJobExperience[] {
    if ( seaJobs.length < 1 ) {
      return [ new SeaJobExperience() ];
    }
    return seaJobs.map(( job ) => new SeaJobExperience(job));
  }
}




// WEBPACK FOOTER //
// ./app/core/entities/cv/cv.ts